import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useQuery } from '@apollo/client';
import { Spin, Typography, Space, Button, Row, Col } from 'antd';
import { EditOutlined } from '@ant-design/icons';
import { DIRECTORY } from '../../../graphql/queries/directories';
import { DirectoryResponse } from '../../../types/directory';
import CardLayout from '../../../layouts/CardLayout';
import { DirectoryValueCard } from '../../../components/Directory/DirectoryValueCard';

const { Title, Text } = Typography;

const DirectoryView: React.FC = () => {
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();
  const { loading, data, refetch } = useQuery<DirectoryResponse>(DIRECTORY, {
    variables: { id },
    fetchPolicy: 'network-only',
  });

  useEffect(() => {
    refetch();
    const handleFocus = () => refetch();
    window.addEventListener('focus', handleFocus);
    return () => window.removeEventListener('focus', handleFocus);
  }, [refetch]);

  if (loading) return <Spin size="large" style={{ display: 'block', margin: '40px auto' }} />;
  if (!data?.directory) return <Text>Directory not found.</Text>;

  return (
    <CardLayout>
      <Space direction="vertical" size="large" style={{ width: '100%' }}>
        <Row justify="space-between" align="middle">
          <Col>
            <Title level={4} style={{ margin: 0 }}>
              {data.directory.name}
            </Title>
            <Text type="secondary">Slug: {data.directory.slug}</Text>
          </Col>
          <Col>
            <Button
              type="primary"
              icon={<EditOutlined />}
              onClick={() => navigate(`/admin/directory/edit/${id}`)}>
              Edit Directory
            </Button>
          </Col>
        </Row>
        <Space direction="vertical" style={{ width: '100%' }}>
          <Title level={5}>Values</Title>
          {data.directory.values.map(value => (
            <DirectoryValueCard key={value.id} value={value} />
          ))}
        </Space>
      </Space>
    </CardLayout>
  );
};

export default DirectoryView;
